var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { align: "left", justify: "center" } },
    [
      _c(
        "div",
        { staticClass: "pa-3", attrs: { align: "center", justify: "center" } },
        [
          _c(
            "v-card",
            { attrs: { align: "left", justify: "left" } },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-3 font-weight-light white black--text" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "grey lighten-4",
                      attrs: { "x-small": "", fab: "", icon: "" }
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "primary--text lighten-2 pa-2" },
                        [_vm._v(" search ")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" Administração > Títulos em Revisão ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            {
              staticClass: "my-2",
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.pesquisaAvancadaTitulos.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "v-expansion-panels",
                {
                  staticClass: "px-3 pt-3 pb-0",
                  model: {
                    value: _vm.panel,
                    callback: function($$v) {
                      _vm.panel = $$v
                    },
                    expression: "panel"
                  }
                },
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c(
                        "v-expansion-panel-header",
                        [
                          _c(
                            "v-card-text",
                            {
                              staticClass:
                                "py-0 px-3 font-weight-light white black--text"
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "grey lighten-4",
                                  attrs: { "x-small": "", fab: "", icon: "" }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass:
                                        "primary--text lighten-2 pa-2"
                                    },
                                    [_vm._v(" mdi-filter ")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" Filtros ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { align: "center" }
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex flex-row",
                                  attrs: {
                                    cols: "12",
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "4"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mt-5",
                                    attrs: {
                                      solo: "",
                                      small: "",
                                      label: "Nosso número",
                                      hint: "Informe o nosso número",
                                      placeholder: "Ex.:477977",
                                      clearable: "",
                                      "data-cy": "filtroNossoNumero",
                                      loading: _vm.loading
                                    },
                                    model: {
                                      value: _vm.filtros.ds_nosso_numero,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filtros,
                                          "ds_nosso_numero",
                                          $$v
                                        )
                                      },
                                      expression: "filtros.ds_nosso_numero"
                                    }
                                  }),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ma-auto ml-2",
                                                  attrs: {
                                                    fab: "",
                                                    "x-small": "",
                                                    elevation: "0"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            color: "grey"
                                                          }
                                                        },
                                                        "v-icon",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " mdi-information-outline "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ])
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Informe o Número do Título")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex flex-row",
                                  attrs: {
                                    cols: "12",
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "4"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mt-5",
                                    attrs: {
                                      solo: "",
                                      small: "",
                                      label: "Nome",
                                      hint:
                                        "Informe o nome para efetuar a busca",
                                      placeholder: "Ex.: José",
                                      clearable: "",
                                      "data-cy": "nomeDevedor",
                                      loading: _vm.loading
                                    },
                                    model: {
                                      value: _vm.filtros.nm_devedor,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filtros, "nm_devedor", $$v)
                                      },
                                      expression: "filtros.nm_devedor"
                                    }
                                  }),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ma-auto ml-2",
                                                  attrs: {
                                                    fab: "",
                                                    "x-small": "",
                                                    elevation: "0"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            color: "grey"
                                                          }
                                                        },
                                                        "v-icon",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " mdi-information-outline "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ])
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " Informe o Nome que deseja encontrar, por exemplo: Ricardo "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex flex-row",
                                  attrs: {
                                    cols: "12",
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "4"
                                  }
                                },
                                [
                                  _c("v-select", {
                                    staticClass: "mt-5",
                                    attrs: {
                                      solo: "",
                                      small: "",
                                      label: "Tipo de revisão",
                                      hint: "Selecione os tipos de revisão",
                                      items: _vm.tiposRevisaoOptions,
                                      "item-text": "text",
                                      "item-value": "value",
                                      multiple: "",
                                      chips: "",
                                      clearable: "",
                                      "data-cy": "tipoRevisao",
                                      loading: _vm.loading
                                    },
                                    model: {
                                      value: _vm.tiposRevisaoSelecionados,
                                      callback: function($$v) {
                                        _vm.tiposRevisaoSelecionados = $$v
                                      },
                                      expression: "tiposRevisaoSelecionados"
                                    }
                                  }),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ma-auto ml-2",
                                                  attrs: {
                                                    fab: "",
                                                    "x-small": "",
                                                    elevation: "0"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            color: "grey"
                                                          }
                                                        },
                                                        "v-icon",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " mdi-information-outline "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ])
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " Selecione os tipos de revisão a serem filtrados "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex flex-row",
                                  attrs: {
                                    cols: "12",
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "4"
                                  }
                                },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "mt-5",
                                    attrs: {
                                      solo: "",
                                      small: "",
                                      label: "Sigla Apresentante",
                                      clearable: "",
                                      items: _vm.apresentantesOrderByCd,
                                      "item-value": "cd_apresentante",
                                      "item-text": "cd_apresentante",
                                      loading:
                                        _vm.loading || _vm.loadingApresentantes
                                    },
                                    model: {
                                      value: _vm.filtros.cd_apresentante,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filtros,
                                          "cd_apresentante",
                                          $$v
                                        )
                                      },
                                      expression: "filtros.cd_apresentante"
                                    }
                                  }),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ma-auto ml-2",
                                                  attrs: {
                                                    fab: "",
                                                    "x-small": "",
                                                    elevation: "0"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            color: "grey"
                                                          }
                                                        },
                                                        "v-icon",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " mdi-information-outline "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ])
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " Informe o apresentante que deseja encontrar - filtro por sigla "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-right",
                  attrs: { xs: "12", sm: "12", md: "12", lg: "12" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-3",
                      attrs: { loading: _vm.loading },
                      on: { click: _vm.limparFiltros }
                    },
                    [
                      _vm._v(" Limpar Filtros "),
                      _c("v-icon", { staticClass: "ml-2" }, [
                        _vm._v("mdi-filter-remove-outline")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0",
                      attrs: { color: "primary", loading: _vm.loading },
                      on: {
                        click: function($event) {
                          return _vm.pesquisaAvancadaTitulos(true)
                        }
                      }
                    },
                    [
                      _vm._v(" Filtrar "),
                      _c("v-icon", { staticClass: "ml-2" }, [_vm._v("search")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-data-table", {
            staticClass: "elevation-1 pa-3",
            attrs: {
              headers: _vm.headers,
              items: _vm.titulos,
              "calculate-widths": "",
              options: _vm.options,
              "server-items-length": _vm.totalTitulos,
              loading: _vm.loading,
              "footer-props": {
                itemsPerPageOptions: [10, 50, 100, 500],
                itemsPerPageText: "Itens por página:"
              },
              "loading-text": "Pesquisando títulos...",
              "no-data-text":
                "Nenhum resultado encontrado... Faça uma pesquisa",
              "no-results-text": "Nenhum título encontrado..."
            },
            on: {
              "update:options": function($event) {
                _vm.options = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.id_titulo`,
                  fn: function({ item }) {
                    return [
                      item.ds_revisao != "" && item.cd_status == 99999
                        ? _c(
                            "span",
                            {
                              style: { color: "red" },
                              attrs: {
                                title: "Este título precisa ser revisado. "
                              }
                            },
                            [_vm._v(" " + _vm._s(item.id_titulo))]
                          )
                        : _c("span", { style: { color: "black" } }, [
                            _vm._v(_vm._s(item.id_titulo))
                          ])
                    ]
                  }
                },
                {
                  key: `item.ds_nosso_numero`,
                  fn: function({ item }) {
                    return [
                      item.ds_revisao != "" && item.cd_status == 99999
                        ? _c(
                            "span",
                            {
                              style: { color: "red" },
                              attrs: {
                                title: "Este título precisa ser revisado. "
                              }
                            },
                            [_vm._v(_vm._s(item.ds_nosso_numero))]
                          )
                        : _c("span", { style: { color: "black" } }, [
                            _vm._v(_vm._s(item.ds_nosso_numero) + " ")
                          ])
                    ]
                  }
                },
                {
                  key: `item.nu_identificacao_devedor`,
                  fn: function({ item }) {
                    return [
                      item.ds_revisao != "" && item.cd_status == 99999
                        ? _c(
                            "span",
                            {
                              style: { color: "red" },
                              attrs: {
                                title: "Este título precisa ser revisado. "
                              }
                            },
                            [_vm._v(_vm._s(_vm.formatDocumento(item)))]
                          )
                        : _c("span", { style: { color: "black" } }, [
                            _vm._v(_vm._s(_vm.formatDocumento(item)))
                          ])
                    ]
                  }
                },
                {
                  key: `item.nm_devedor`,
                  fn: function({ item }) {
                    return [
                      item.ds_revisao != "" && item.cd_status == 99999
                        ? _c(
                            "span",
                            {
                              style: { color: "red" },
                              attrs: {
                                title: "Este título precisa ser revisado. "
                              }
                            },
                            [_vm._v(_vm._s(item.nm_devedor))]
                          )
                        : _c("span", { style: { color: "black" } }, [
                            _vm._v(_vm._s(item.nm_devedor))
                          ])
                    ]
                  }
                },
                {
                  key: `item.cd_status`,
                  fn: function({ item }) {
                    return [
                      item.ds_revisao != "" && item.cd_status == 99999
                        ? _c(
                            "span",
                            {
                              style: { color: "red" },
                              attrs: {
                                title: "Este título precisa ser revisado. "
                              }
                            },
                            [_vm._v(_vm._s(_vm.getDescSituacao(item)))]
                          )
                        : _c("span", { style: { color: "black" } }, [
                            _vm._v(_vm._s(_vm.getDescSituacao(item)))
                          ])
                    ]
                  }
                },
                {
                  key: `item.cd_uf_devedor`,
                  fn: function({ item }) {
                    return [
                      item.ds_revisao != "" && item.cd_status == 99999
                        ? _c(
                            "span",
                            {
                              style: { color: "red" },
                              attrs: {
                                title: "Este título precisa ser revisado. "
                              }
                            },
                            [_vm._v(_vm._s(item.cd_uf_devedor))]
                          )
                        : _c("span", { style: { color: "black" } }, [
                            _vm._v(_vm._s(item.cd_uf_devedor))
                          ])
                    ]
                  }
                },
                {
                  key: `item.ds_revisao`,
                  fn: function({ item }) {
                    return [
                      item.ds_revisao
                        ? _c(
                            "span",
                            { style: { color: "red", fontWeight: "bold" } },
                            [_vm._v(_vm._s(item.ds_revisao))]
                          )
                        : _c("span", [_vm._v("-")])
                    ]
                  }
                },
                {
                  key: `item.action`,
                  fn: function(props) {
                    return [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2 grey white--text",
                          style: { color: "primary" },
                          attrs: {
                            elevation: "1",
                            width: "100%",
                            "full-width": "",
                            small: "",
                            "data-cy": `editarTitulo${props.index}`
                          },
                          on: {
                            click: function($event) {
                              return _vm.abrirDetalhesTitulo(props.item)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", style: { color: "white" } },
                            [_vm._v(" edit ")]
                          ),
                          _vm._v(" Corrigir ")
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "900px",
            persistent: "",
            "overlay-opacity": "0.8"
          },
          model: {
            value: _vm.showRevisaoModal,
            callback: function($$v) {
              _vm.showRevisaoModal = $$v
            },
            expression: "showRevisaoModal"
          }
        },
        [
          _vm.showRevisaoModal && _vm.selectedTitulo
            ? _c("DetalheTituloRevisao", {
                attrs: { titulo: _vm.selectedTitulo },
                on: { fecharModal: _vm.handleFecharModal }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }